import { z } from 'zod'

import { groupLearningItemParser } from '../../models/GroupLearningItem'
import * as api from '../api'
import { useApiQuery } from '../useApiQuery'
import { ReturnsLearningItems, ReturnsGroupLearningAssignments, ReturnsGroups } from '../useInvalidate'

export default function useGroupLearningItems(uuid: string | null | undefined) {
  const { data, ...result } = useApiQuery({
    queryKey: ['groupLearningItems', ReturnsGroups, ReturnsGroupLearningAssignments, ReturnsLearningItems, uuid],
    placeholderData: (previousData) => previousData || [],
    queryFn: async () => {
      if (!uuid) {
        return null
      }
      return z.array(groupLearningItemParser).parse(await api.get(`group/${encodeURIComponent(uuid)}/learning-items`))
    },
  })

  return { groupLearningItems: data || [], ...result }
}
